// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 4 hooks for backend/payroll.

import { useBackend } from '../useBackend'

/** POST /api/payroll/decideServiceHoursClaim */
export function useDecideServiceHoursClaim<T = any>() {
  return useBackend<T>('payroll/decideServiceHoursClaim')
}

/** POST /api/payroll/decideServiceHoursReferral */
export function useDecideServiceHoursReferral<T = any>() {
  return useBackend<T>('payroll/decideServiceHoursReferral')
}

/** POST /api/payroll/getServiceHours */
export function useGetServiceHours<T = any>() {
  return useBackend<T>('payroll/getServiceHours')
}

/** POST /api/payroll/getServiceHoursReport */
export function useGetServiceHoursReport<T = any>() {
  return useBackend<T>('payroll/getServiceHoursReport')
}
